import { render, staticRenderFns } from "./ReservationSuccess.vue?vue&type=template&id=fd4c0520&scoped=true"
import script from "./ReservationSuccess.vue?vue&type=script&lang=js"
export * from "./ReservationSuccess.vue?vue&type=script&lang=js"
import style0 from "./ReservationSuccess.vue?vue&type=style&index=0&id=fd4c0520&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd4c0520",
  null
  
)

export default component.exports